import { render, staticRenderFns } from "./PostLabel.vue?vue&type=template&id=06513f5d&"
import script from "./PostLabel.vue?vue&type=script&lang=js&"
export * from "./PostLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports